import './WardProgram.css.proxy.js';
/* src/components/WardProgram.svelte generated by Svelte v3.29.4 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	component_subscribe,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	set_data,
	space,
	text,
	transition_in,
	transition_out
} from "../../web_modules/svelte/internal.js";

import "./css/style.css.proxy.js";
import { operationStore, query } from "../../web_modules/@urql/svelte.js";
import ProgramItem from "./ProgramItem.js";
import Hymn from "./Hymn.js";
import { queryProgram } from "./data/queries.js";
import { onMount } from "../../web_modules/svelte.js";
import PageQrCode from "./PageQrCode.js";
import { IconType } from "./data/icons.js";
import Head from "./Head.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[9] = list[i];
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[12] = list[i];
	return child_ctx;
}

// (60:0) {:else}
function create_else_block(ctx) {
	let h1;
	let t0;
	let t1_value = /*data*/ ctx[1].Ward + "";
	let t1;
	let t2;
	let h5;
	let t3;
	let t4;
	let programitem0;
	let t5;
	let hymn0;
	let t6;
	let programitem1;
	let t7;
	let hymn1;
	let t8;
	let programitem2;
	let t9;
	let t10;
	let hymn2;
	let t11;
	let programitem3;
	let t12;
	let hr0;
	let t13;
	let h20;
	let t14;
	let t15;
	let div;
	let t16;
	let pageqrcode;
	let t17;
	let hr1;
	let t18;
	let h21;
	let t19;
	let t20;
	let t21;
	let hr2;
	let t22;
	let switch_instance;
	let switch_instance_anchor;
	let current;

	programitem0 = new ProgramItem({
			props: {
				title: "Conducting",
				content: /*data*/ ctx[1].conducting,
				icon: IconType.person
			}
		});

	hymn0 = new Hymn({
			props: {
				title: "Opening Hymn",
				number: /*data*/ ctx[1].openingHymn.number
			}
		});

	programitem1 = new ProgramItem({
			props: {
				title: "Opening Prayer",
				content: /*data*/ ctx[1].invocation,
				icon: IconType.prayer
			}
		});

	hymn1 = new Hymn({
			props: {
				title: "Sacrament Hymn",
				number: /*data*/ ctx[1].sacramentHymn && /*data*/ ctx[1].sacramentHymn.number
			}
		});

	programitem2 = new ProgramItem({
			props: {
				icon: IconType.sacrament,
				title: "Sacrament",
				content: "Administered by the priesthood bretheren"
			}
		});

	let each_value_1 = /*data*/ ctx[1].programItems;
	let each_blocks_1 = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks_1[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	const out = i => transition_out(each_blocks_1[i], 1, 1, () => {
		each_blocks_1[i] = null;
	});

	hymn2 = new Hymn({
			props: {
				title: "Closing Hymn",
				number: /*data*/ ctx[1].closingHymn.number
			}
		});

	programitem3 = new ProgramItem({
			props: {
				title: "Closing Prayer",
				content: /*data*/ ctx[1].benediction,
				icon: IconType.prayer
			}
		});

	pageqrcode = new PageQrCode({});
	let each_value = /*data*/ ctx[1].announcements;
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out_1 = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	var switch_value = /*Calendar*/ ctx[0];

	function switch_props(ctx) {
		return {};
	}

	if (switch_value) {
		switch_instance = new switch_value(switch_props(ctx));
	}

	return {
		c() {
			h1 = element("h1");
			t0 = text("Welcome ");
			t1 = text(t1_value);
			t2 = space();
			h5 = element("h5");
			t3 = text(/*date*/ ctx[3]);
			t4 = space();
			create_component(programitem0.$$.fragment);
			t5 = space();
			create_component(hymn0.$$.fragment);
			t6 = space();
			create_component(programitem1.$$.fragment);
			t7 = space();
			create_component(hymn1.$$.fragment);
			t8 = space();
			create_component(programitem2.$$.fragment);
			t9 = space();

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].c();
			}

			t10 = space();
			create_component(hymn2.$$.fragment);
			t11 = space();
			create_component(programitem3.$$.fragment);
			t12 = space();
			hr0 = element("hr");
			t13 = space();
			h20 = element("h2");
			t14 = text("Share");
			t15 = space();
			div = element("div");
			t16 = text("You can let the person sitting next to you open this page with the following\n    QR code:\n\n    ");
			create_component(pageqrcode.$$.fragment);
			t17 = space();
			hr1 = element("hr");
			t18 = space();
			h21 = element("h2");
			t19 = text("Announcements");
			t20 = space();

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t21 = space();
			hr2 = element("hr");
			t22 = space();
			if (switch_instance) create_component(switch_instance.$$.fragment);
			switch_instance_anchor = empty();
			this.h();
		},
		l(nodes) {
			h1 = claim_element(nodes, "H1", {});
			var h1_nodes = children(h1);
			t0 = claim_text(h1_nodes, "Welcome ");
			t1 = claim_text(h1_nodes, t1_value);
			h1_nodes.forEach(detach);
			t2 = claim_space(nodes);
			h5 = claim_element(nodes, "H5", { class: true });
			var h5_nodes = children(h5);
			t3 = claim_text(h5_nodes, /*date*/ ctx[3]);
			h5_nodes.forEach(detach);
			t4 = claim_space(nodes);
			claim_component(programitem0.$$.fragment, nodes);
			t5 = claim_space(nodes);
			claim_component(hymn0.$$.fragment, nodes);
			t6 = claim_space(nodes);
			claim_component(programitem1.$$.fragment, nodes);
			t7 = claim_space(nodes);
			claim_component(hymn1.$$.fragment, nodes);
			t8 = claim_space(nodes);
			claim_component(programitem2.$$.fragment, nodes);
			t9 = claim_space(nodes);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].l(nodes);
			}

			t10 = claim_space(nodes);
			claim_component(hymn2.$$.fragment, nodes);
			t11 = claim_space(nodes);
			claim_component(programitem3.$$.fragment, nodes);
			t12 = claim_space(nodes);
			hr0 = claim_element(nodes, "HR", {});
			t13 = claim_space(nodes);
			h20 = claim_element(nodes, "H2", { class: true });
			var h20_nodes = children(h20);
			t14 = claim_text(h20_nodes, "Share");
			h20_nodes.forEach(detach);
			t15 = claim_space(nodes);
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			t16 = claim_text(div_nodes, "You can let the person sitting next to you open this page with the following\n    QR code:\n\n    ");
			claim_component(pageqrcode.$$.fragment, div_nodes);
			div_nodes.forEach(detach);
			t17 = claim_space(nodes);
			hr1 = claim_element(nodes, "HR", {});
			t18 = claim_space(nodes);
			h21 = claim_element(nodes, "H2", { class: true });
			var h21_nodes = children(h21);
			t19 = claim_text(h21_nodes, "Announcements");
			h21_nodes.forEach(detach);
			t20 = claim_space(nodes);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(nodes);
			}

			t21 = claim_space(nodes);
			hr2 = claim_element(nodes, "HR", {});
			t22 = claim_space(nodes);
			if (switch_instance) claim_component(switch_instance.$$.fragment, nodes);
			switch_instance_anchor = empty();
			this.h();
		},
		h() {
			attr(h5, "class", "svelte-1r70eom");
			attr(h20, "class", "svelte-1r70eom");
			attr(div, "class", "light-container container");
			attr(h21, "class", "svelte-1r70eom");
		},
		m(target, anchor) {
			insert(target, h1, anchor);
			append(h1, t0);
			append(h1, t1);
			insert(target, t2, anchor);
			insert(target, h5, anchor);
			append(h5, t3);
			insert(target, t4, anchor);
			mount_component(programitem0, target, anchor);
			insert(target, t5, anchor);
			mount_component(hymn0, target, anchor);
			insert(target, t6, anchor);
			mount_component(programitem1, target, anchor);
			insert(target, t7, anchor);
			mount_component(hymn1, target, anchor);
			insert(target, t8, anchor);
			mount_component(programitem2, target, anchor);
			insert(target, t9, anchor);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].m(target, anchor);
			}

			insert(target, t10, anchor);
			mount_component(hymn2, target, anchor);
			insert(target, t11, anchor);
			mount_component(programitem3, target, anchor);
			insert(target, t12, anchor);
			insert(target, hr0, anchor);
			insert(target, t13, anchor);
			insert(target, h20, anchor);
			append(h20, t14);
			insert(target, t15, anchor);
			insert(target, div, anchor);
			append(div, t16);
			mount_component(pageqrcode, div, null);
			insert(target, t17, anchor);
			insert(target, hr1, anchor);
			insert(target, t18, anchor);
			insert(target, h21, anchor);
			append(h21, t19);
			insert(target, t20, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert(target, t21, anchor);
			insert(target, hr2, anchor);
			insert(target, t22, anchor);

			if (switch_instance) {
				mount_component(switch_instance, target, anchor);
			}

			insert(target, switch_instance_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty & /*data*/ 2) && t1_value !== (t1_value = /*data*/ ctx[1].Ward + "")) set_data(t1, t1_value);
			if (!current || dirty & /*date*/ 8) set_data(t3, /*date*/ ctx[3]);
			const programitem0_changes = {};
			if (dirty & /*data*/ 2) programitem0_changes.content = /*data*/ ctx[1].conducting;
			programitem0.$set(programitem0_changes);
			const hymn0_changes = {};
			if (dirty & /*data*/ 2) hymn0_changes.number = /*data*/ ctx[1].openingHymn.number;
			hymn0.$set(hymn0_changes);
			const programitem1_changes = {};
			if (dirty & /*data*/ 2) programitem1_changes.content = /*data*/ ctx[1].invocation;
			programitem1.$set(programitem1_changes);
			const hymn1_changes = {};
			if (dirty & /*data*/ 2) hymn1_changes.number = /*data*/ ctx[1].sacramentHymn && /*data*/ ctx[1].sacramentHymn.number;
			hymn1.$set(hymn1_changes);

			if (dirty & /*data, IconType*/ 2) {
				each_value_1 = /*data*/ ctx[1].programItems;
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks_1[i]) {
						each_blocks_1[i].p(child_ctx, dirty);
						transition_in(each_blocks_1[i], 1);
					} else {
						each_blocks_1[i] = create_each_block_1(child_ctx);
						each_blocks_1[i].c();
						transition_in(each_blocks_1[i], 1);
						each_blocks_1[i].m(t10.parentNode, t10);
					}
				}

				group_outros();

				for (i = each_value_1.length; i < each_blocks_1.length; i += 1) {
					out(i);
				}

				check_outros();
			}

			const hymn2_changes = {};
			if (dirty & /*data*/ 2) hymn2_changes.number = /*data*/ ctx[1].closingHymn.number;
			hymn2.$set(hymn2_changes);
			const programitem3_changes = {};
			if (dirty & /*data*/ 2) programitem3_changes.content = /*data*/ ctx[1].benediction;
			programitem3.$set(programitem3_changes);

			if (dirty & /*data, dateFormat*/ 34) {
				each_value = /*data*/ ctx[1].announcements;
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(t21.parentNode, t21);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out_1(i);
				}

				check_outros();
			}

			if (switch_value !== (switch_value = /*Calendar*/ ctx[0])) {
				if (switch_instance) {
					group_outros();
					const old_component = switch_instance;

					transition_out(old_component.$$.fragment, 1, 0, () => {
						destroy_component(old_component, 1);
					});

					check_outros();
				}

				if (switch_value) {
					switch_instance = new switch_value(switch_props(ctx));
					create_component(switch_instance.$$.fragment);
					transition_in(switch_instance.$$.fragment, 1);
					mount_component(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
				} else {
					switch_instance = null;
				}
			} else if (switch_value) {
				
			}
		},
		i(local) {
			if (current) return;
			transition_in(programitem0.$$.fragment, local);
			transition_in(hymn0.$$.fragment, local);
			transition_in(programitem1.$$.fragment, local);
			transition_in(hymn1.$$.fragment, local);
			transition_in(programitem2.$$.fragment, local);

			for (let i = 0; i < each_value_1.length; i += 1) {
				transition_in(each_blocks_1[i]);
			}

			transition_in(hymn2.$$.fragment, local);
			transition_in(programitem3.$$.fragment, local);
			transition_in(pageqrcode.$$.fragment, local);

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			if (switch_instance) transition_in(switch_instance.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(programitem0.$$.fragment, local);
			transition_out(hymn0.$$.fragment, local);
			transition_out(programitem1.$$.fragment, local);
			transition_out(hymn1.$$.fragment, local);
			transition_out(programitem2.$$.fragment, local);
			each_blocks_1 = each_blocks_1.filter(Boolean);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				transition_out(each_blocks_1[i]);
			}

			transition_out(hymn2.$$.fragment, local);
			transition_out(programitem3.$$.fragment, local);
			transition_out(pageqrcode.$$.fragment, local);
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			if (switch_instance) transition_out(switch_instance.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(h1);
			if (detaching) detach(t2);
			if (detaching) detach(h5);
			if (detaching) detach(t4);
			destroy_component(programitem0, detaching);
			if (detaching) detach(t5);
			destroy_component(hymn0, detaching);
			if (detaching) detach(t6);
			destroy_component(programitem1, detaching);
			if (detaching) detach(t7);
			destroy_component(hymn1, detaching);
			if (detaching) detach(t8);
			destroy_component(programitem2, detaching);
			if (detaching) detach(t9);
			destroy_each(each_blocks_1, detaching);
			if (detaching) detach(t10);
			destroy_component(hymn2, detaching);
			if (detaching) detach(t11);
			destroy_component(programitem3, detaching);
			if (detaching) detach(t12);
			if (detaching) detach(hr0);
			if (detaching) detach(t13);
			if (detaching) detach(h20);
			if (detaching) detach(t15);
			if (detaching) detach(div);
			destroy_component(pageqrcode);
			if (detaching) detach(t17);
			if (detaching) detach(hr1);
			if (detaching) detach(t18);
			if (detaching) detach(h21);
			if (detaching) detach(t20);
			destroy_each(each_blocks, detaching);
			if (detaching) detach(t21);
			if (detaching) detach(hr2);
			if (detaching) detach(t22);
			if (detaching) detach(switch_instance_anchor);
			if (switch_instance) destroy_component(switch_instance, detaching);
		}
	};
}

// (58:25) 
function create_if_block_1(ctx) {
	let p;
	let t0;
	let t1_value = /*$program*/ ctx[2].error.message + "";
	let t1;

	return {
		c() {
			p = element("p");
			t0 = text("Oh no... ");
			t1 = text(t1_value);
		},
		l(nodes) {
			p = claim_element(nodes, "P", {});
			var p_nodes = children(p);
			t0 = claim_text(p_nodes, "Oh no... ");
			t1 = claim_text(p_nodes, t1_value);
			p_nodes.forEach(detach);
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t0);
			append(p, t1);
		},
		p(ctx, dirty) {
			if (dirty & /*$program*/ 4 && t1_value !== (t1_value = /*$program*/ ctx[2].error.message + "")) set_data(t1, t1_value);
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (55:0) {#if $program.fetching}
function create_if_block(ctx) {
	let h1;
	let t0;
	let t1;
	let p;
	let t2;

	return {
		c() {
			h1 = element("h1");
			t0 = text("Welcome");
			t1 = space();
			p = element("p");
			t2 = text("Loading...");
		},
		l(nodes) {
			h1 = claim_element(nodes, "H1", {});
			var h1_nodes = children(h1);
			t0 = claim_text(h1_nodes, "Welcome");
			h1_nodes.forEach(detach);
			t1 = claim_space(nodes);
			p = claim_element(nodes, "P", {});
			var p_nodes = children(p);
			t2 = claim_text(p_nodes, "Loading...");
			p_nodes.forEach(detach);
		},
		m(target, anchor) {
			insert(target, h1, anchor);
			append(h1, t0);
			insert(target, t1, anchor);
			insert(target, p, anchor);
			append(p, t2);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(h1);
			if (detaching) detach(t1);
			if (detaching) detach(p);
		}
	};
}

// (99:43) 
function create_if_block_5(ctx) {
	let programitem;
	let current;

	programitem = new ProgramItem({
			props: {
				title: /*item*/ ctx[12].title,
				content: /*item*/ ctx[12].subTitle
			}
		});

	return {
		c() {
			create_component(programitem.$$.fragment);
		},
		l(nodes) {
			claim_component(programitem.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(programitem, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const programitem_changes = {};
			if (dirty & /*data*/ 2) programitem_changes.title = /*item*/ ctx[12].title;
			if (dirty & /*data*/ 2) programitem_changes.content = /*item*/ ctx[12].subTitle;
			programitem.$set(programitem_changes);
		},
		i(local) {
			if (current) return;
			transition_in(programitem.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(programitem.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(programitem, detaching);
		}
	};
}

// (94:50) 
function create_if_block_4(ctx) {
	let programitem;
	let current;

	programitem = new ProgramItem({
			props: {
				title: /*item*/ ctx[12].songTitle,
				content: /*item*/ ctx[12].performers.join(", "),
				icon: IconType.musicalNumber
			}
		});

	return {
		c() {
			create_component(programitem.$$.fragment);
		},
		l(nodes) {
			claim_component(programitem.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(programitem, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const programitem_changes = {};
			if (dirty & /*data*/ 2) programitem_changes.title = /*item*/ ctx[12].songTitle;
			if (dirty & /*data*/ 2) programitem_changes.content = /*item*/ ctx[12].performers.join(", ");
			programitem.$set(programitem_changes);
		},
		i(local) {
			if (current) return;
			transition_in(programitem.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(programitem.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(programitem, detaching);
		}
	};
}

// (89:44) 
function create_if_block_3(ctx) {
	let programitem;
	let current;

	programitem = new ProgramItem({
			props: {
				title: "Speaker",
				content: /*item*/ ctx[12].speaker,
				icon: IconType.speaker
			}
		});

	return {
		c() {
			create_component(programitem.$$.fragment);
		},
		l(nodes) {
			claim_component(programitem.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(programitem, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const programitem_changes = {};
			if (dirty & /*data*/ 2) programitem_changes.content = /*item*/ ctx[12].speaker;
			programitem.$set(programitem_changes);
		},
		i(local) {
			if (current) return;
			transition_in(programitem.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(programitem.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(programitem, detaching);
		}
	};
}

// (87:4) {#if item.__typename === 'Hymn'}
function create_if_block_2(ctx) {
	let hymn;
	let current;

	hymn = new Hymn({
			props: {
				title: "Hymn",
				number: /*item*/ ctx[12].number
			}
		});

	return {
		c() {
			create_component(hymn.$$.fragment);
		},
		l(nodes) {
			claim_component(hymn.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(hymn, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const hymn_changes = {};
			if (dirty & /*data*/ 2) hymn_changes.number = /*item*/ ctx[12].number;
			hymn.$set(hymn_changes);
		},
		i(local) {
			if (current) return;
			transition_in(hymn.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(hymn.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(hymn, detaching);
		}
	};
}

// (86:2) {#each data.programItems as item}
function create_each_block_1(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_2, create_if_block_3, create_if_block_4, create_if_block_5];
	const if_blocks = [];

	function select_block_type_1(ctx, dirty) {
		if (/*item*/ ctx[12].__typename === "Hymn") return 0;
		if (/*item*/ ctx[12].__typename === "Speaker") return 1;
		if (/*item*/ ctx[12].__typename === "MusicalNumber") return 2;
		if (/*item*/ ctx[12].__typename === "Custom") return 3;
		return -1;
	}

	if (~(current_block_type_index = select_block_type_1(ctx, -1))) {
		if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	}

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		l(nodes) {
			if (if_block) if_block.l(nodes);
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (~current_block_type_index) {
				if_blocks[current_block_type_index].m(target, anchor);
			}

			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_1(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].p(ctx, dirty);
				}
			} else {
				if (if_block) {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
				}

				if (~current_block_type_index) {
					if_block = if_blocks[current_block_type_index];

					if (!if_block) {
						if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block.c();
					}

					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				} else {
					if_block = null;
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (~current_block_type_index) {
				if_blocks[current_block_type_index].d(detaching);
			}

			if (detaching) detach(if_block_anchor);
		}
	};
}

// (126:2) {#each data.announcements as announcement}
function create_each_block(ctx) {
	let div;
	let programitem;
	let current;

	programitem = new ProgramItem({
			props: {
				title: "" + (/*announcement*/ ctx[9].name + " - " + /*dateFormat*/ ctx[5](/*announcement*/ ctx[9].date)),
				content: /*announcement*/ ctx[9].description
			}
		});

	return {
		c() {
			div = element("div");
			create_component(programitem.$$.fragment);
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", {});
			var div_nodes = children(div);
			claim_component(programitem.$$.fragment, div_nodes);
			div_nodes.forEach(detach);
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(programitem, div, null);
			current = true;
		},
		p(ctx, dirty) {
			const programitem_changes = {};
			if (dirty & /*data*/ 2) programitem_changes.title = "" + (/*announcement*/ ctx[9].name + " - " + /*dateFormat*/ ctx[5](/*announcement*/ ctx[9].date));
			if (dirty & /*data*/ 2) programitem_changes.content = /*announcement*/ ctx[9].description;
			programitem.$set(programitem_changes);
		},
		i(local) {
			if (current) return;
			transition_in(programitem.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(programitem.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(programitem);
		}
	};
}

function create_fragment(ctx) {
	let head;
	let t;
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	head = new Head({});
	const if_block_creators = [create_if_block, create_if_block_1, create_else_block];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*$program*/ ctx[2].fetching) return 0;
		if (/*$program*/ ctx[2].error) return 1;
		return 2;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			create_component(head.$$.fragment);
			t = space();
			if_block.c();
			if_block_anchor = empty();
		},
		l(nodes) {
			claim_component(head.$$.fragment, nodes);
			t = claim_space(nodes);
			if_block.l(nodes);
			if_block_anchor = empty();
		},
		m(target, anchor) {
			mount_component(head, target, anchor);
			insert(target, t, anchor);
			if_blocks[current_block_type_index].m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				}

				transition_in(if_block, 1);
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},
		i(local) {
			if (current) return;
			transition_in(head.$$.fragment, local);
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(head.$$.fragment, local);
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			destroy_component(head, detaching);
			if (detaching) detach(t);
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $program;
	var _a, _b;
	
	const program = operationStore(queryProgram);
	component_subscribe($$self, program, value => $$invalidate(2, $program = value));
	let Calendar;

	onMount(async () => {
		// if this isn't imported first it will throw an error...
		await import("../../web_modules/@fullcalendar/core/vdom.js");

		const module = await import("./Calendar.js");
		$$invalidate(0, Calendar = module.default);
	});

	query(program);

	function dateFormat(date) {
		return new Intl.DateTimeFormat("en-US",
		{
				weekday: "long",
				year: "numeric",
				month: "long",
				day: "numeric",
				hour: "numeric",
				minute: "numeric"
			}).format(new Date(date));
	}

	let data;
	let dateParts;
	let date;

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*$program, _a*/ 68) {
			$: $$invalidate(1, data = $$invalidate(6, _a = $program.data) === null || _a === void 0
			? void 0
			: _a.Program);
		}

		if ($$self.$$.dirty & /*data, _b*/ 130) {
			$: $$invalidate(8, dateParts = ($$invalidate(7, _b = data === null || data === void 0
			? void 0
			: data.date.split("-")) !== null && _b !== void 0
			? _b
			: []).map(Number));
		}

		if ($$self.$$.dirty & /*dateParts*/ 256) {
			$: $$invalidate(3, date = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]).toLocaleDateString("en-US", {
				weekday: "long",
				year: "numeric",
				month: "long",
				day: "numeric"
			}));
		}
	};

	return [Calendar, data, $program, date, program, dateFormat];
}

class WardProgram extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default WardProgram;
//# sourceMappingURL=WardProgram.js.map
